import { RecordButton } from '@backrs_ui/common-ui';

import type { AudioRecorderStatus } from '@backrs_ui/common-ui/src/hooks/useAudioRecorder';

import { Theme, Tooltip } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';

import { buttonSx } from './EditorToolbarButton';

export type DictationControls = Readonly<{
  status: AudioRecorderStatus;
  onStart: () => void;
  onStop: () => void;
}>;

const LABELS = {
  idle: 'Dictate note',
  recording: 'Stop dictating',
  transcribing: 'Converting speech to text…',
} as const satisfies Record<AudioRecorderStatus, string>;

export const DictationToolbarButton = ({ status, onStart, onStop }: DictationControls) => (
  <Tooltip title={LABELS[status]} disableInteractive enterDelay={400}>
    <span>
      <RecordButton
        id="rt-toolbar-dictate"
        status={status}
        label={LABELS[status]}
        onStart={onStart}
        onStop={onStop}
        sx={toolbarRecordSx}
        // Preserves the editor's caret, which a focus change would otherwise drop.
        onMouseDown={(event) => {
          event.preventDefault();
        }}
      />
    </span>
  </Tooltip>
);

const toolbarRecordSx = (theme: Theme): SystemStyleObject<Theme> => buttonSx(false)(theme);
